export default class Contract {
  constructor(
    idInDB,
    externalId,
    number,
    date,
    lesseeCounterpartyId,
    lessorCounterpartyIds,
    turnoverPercentage,
    responsible,
    revenues,
    commentary,
    type,
    status,
    externalLink,
    externalLinkName,
    prolongationType,
    createDate,
  ) {
    this.idInDB = idInDB; // can be null
    this.externalId = externalId; // can be null
    this.externalLink = externalLink; // can be null
    this.externalLinkName = externalLinkName; // can be null
    this.number = number;
    this.date = date; // can be null
    this.lesseeCounterpartyId = lesseeCounterpartyId; // can be null
    this.lessorCounterpartyIds = lessorCounterpartyIds; // can be empy array
    this.turnoverPercentage = turnoverPercentage;
    this.responsible = responsible;
    this.revenues = revenues;
    this.commentary = commentary;
    this.type = type;
    this.status = status;
    this.prolongationType = prolongationType; // can be null
    this.createDate = createDate; // can be null
  }

  static createFromData(data) {
    return new Contract(
      data.idInDB,
      data.externalId,
      data.number,
      data.date,
      data.lesseeCounterpartyId,
      data.lessorCounterpartyIds,
      data.turnoverPercentage,
      data.responsible,
      data.revenues,
      data.commentary,
      data.type,
      data.status,
      data.externalLink,
      data.externalLinkName,
      data.prolongationType,
      data.createDate,
    );
  }

  static createNew() {
    return new Contract(
      null,
      null,
      null, // number
      null, // date
      null,
      [],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    );
  }
}
